import React from "react";
import RegisterImg from "../images/register.png";
import apiCallService from '../../service/api-call-service';
import { setOrderDetails, setUpdatedDetails } from '../../redux/on-boarding/on-boarding.action';
import { store } from '../../redux/store';
import ApiCallingService from '../../service/api-call-service';
import GenerateRequestId from "../../common-function/GenerateRequestId";
import { showIciciKycSection } from '../../redux/div-show-and-hide/div-show-and-hide.action';
import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { connect } from 'react-redux';

class IciciOnboarding extends React.Component{
    constructor(props){
        super(props);
        this.state={
			curTime: new Date().toLocaleString(),
			orderDetails: '',
			messagePopUpHidden: false,
            message: '',
            severity: '',
			name: '',
			mobile: '',
			aadhaarNumber: '',
			panNumber: ''


        }
    }
    
	componentDidMount = async () => {

        this.setState({ orderDetails: '' });

		const queryParams = new URLSearchParams(window.location.search);
		const orderId = queryParams.get('order_id');

		console.log('OrderId : ',orderId);

        var url = process.env.REACT_APP_GET_KYC_ORDER_DETAILS_URL+orderId;

        console.log('Get Kyc Order Details URL : ', url);

        var response = await apiCallService.getMethodCallWithoutParam(url);

        console.log('Get Kyc Order Details Response : ', response);

        if (!(response === undefined) && (response.response_code == 0)) {
            this.setState({ orderDetails: response.response.order_details });

			this.setState({ name: response.response.order_details.name });
			this.setState({ mobile: response.response.order_details.mobile });
			this.setState({ aadhaarNumber: response.response.order_details.aadhaarNumber });
			this.setState({ panNumber: response.response.order_details.panNumber });

			store.dispatch(setOrderDetails({orderDetails: response.response.order_details}));
        }
    }

	handleChange = (event) => {
		const { value, name } = event.target;
		this.setState({ [name]: value });
    };

    handleBackClick = (event) => {
    }

	submitFormData = async (event) => {
        event.preventDefault();

		var updatedDetails = {
			name: this.state.name,
            mobile: this.state.mobile,
            aadhaarNumber: this.state.aadhaarNumber,
            panNumber: this.state.panNumber,
		}
        
        store.dispatch(setUpdatedDetails(updatedDetails));

		const requestId = GenerateRequestId.geneRateRequestId();

		var long = '';
        var lat = '';
        navigator.geolocation.watchPosition(async function (position) {
            long = position.coords.longitude;
            lat = position.coords.latitude;
            console.log("Latitude is :", position.coords.latitude);
            console.log("Longitude is :", position.coords.longitude);
        });

		const request = {
			"request": {
				"requestId": requestId,
				"latitude": "22.9734229", //lat,
				"longitude": "78.6568942", //long,
				"timestamp": this.state.curTime,
				"deviceImei": "F58032B1-496D-44E1-950F-BB8DC4F362A9",
				"merchants": {
					"merchantLoginId": this.state.orderDetails.roMdn,
					"merchantLoginPin": "",
					"merchantName": this.state.name,
					"merchantPhoneNumber": this.state.mobile,
					"companyLegalName": this.state.orderDetails.shopName,
					"companyMarketingName": "",
					"merchantBranch": "",
					"emailId": this.state.orderDetails.email,
					"merchantPinCode": this.state.orderDetails.pinCode,
					"tan": "",
					"merchantCityName": this.state.orderDetails.cityName,
					"merchantDistrictName": "",
					"cancellationCheckImages": "",
					"shopAndPanImage": "",
					"ekycDocuments": "",
					"merchantAddress": {
						"merchantAddress": this.state.orderDetails.address,
						"merchantState": this.state.orderDetails.stateName
					},
					"kyc": {
						"userPan": this.state.panNumber,
						"aadhaarNumber": this.state.aadhaarNumber,
						"gstInNumber": "",
						"companyOrShopPan": ""
					},
					"settlement": {
						"companyBankAccountNumber": this.state.orderDetails.accountNumber,
						"bankIfscCode": this.state.orderDetails.ifscCode,
						"companyBankName": this.state.orderDetails.bankName,
						"bankBranchName": this.state.orderDetails.bankAddress,
						"bankAccountName": ""
					}
				}
			}
		}

		console.log('On Boarding request', request);

		var url = process.env.REACT_APP_FingPay_On_Boarding_URL;

		console.log('On Boarding url', url);

		var response = await ApiCallingService.postMethodCall(url, request);

		console.log('On Boarding response', response);

        if (!(response === undefined) && (response.response_code == 0)) {
			
			store.dispatch(showIciciKycSection());

			this.setState({messagePopUpHidden: true });
			this.setState({severity: "success" });
            this.setState({message:response.response_description});
                    
		}
		else if (!(response === undefined) && !(response.response_description === undefined)) {
			this.setState({messagePopUpHidden: true });
			this.setState({severity: "error" });
			this.setState({message: response.response_description });
				
		} else {
			this.setState({messagePopUpHidden: true })
			this.setState({message:response});
			this.setState({severity: "error" });
		}
	}

    render(){
        return(
           <div className="mid-contant">
	       <div className="container">		
		   <div className="row">
			<div className="col-12">
				<div className="head">
					<h2>ICICI KYC Process</h2>
				</div>
			</div>
			<Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
				open={this.state.messagePopUpHidden}
				autoHideDuration={3000}
				onClose={e => this.setState({ messagePopUpHidden: false })}
			>
			<Alert onClose={e => this.setState({ messagePopUpHidden: false })} severity={this.state.severity}>
				{this.state.message}
			</Alert>
			</Snackbar>
			<div className="col-12">
				<div className="kycform">
					<div className="row mb-3">
						<div className="col-12 col-lg-7">
							<form onSubmit={this.submitFormData} autocomplete="off" >
							<div className="row">								
								<div className="col-12 col-md-6">
									<div className="form-floating">
										<input type="text" className="form-control" id="firsname" placeholder="Enter name" name="name" value={this.state.name} onChange={this.handleChange} required />
										<label for="firsname">Full Name</label>
									</div>
								</div>
								
								<div className="col-12 col-md-6">
									<div className="form-floating">
										<input type="text" className="form-control" id="mobile" placeholder="Enter mobile no." name="mobile" value={this.state.mobile} onChange={this.handleChange} required />
										<label for="mobile">Mobile number</label>
									</div>
								</div>
								
								<div className="col-12 col-md-6">
									<div className="form-floating">
										<input type="text" className="form-control" id="lastname" placeholder="Enter Aadhaar" name="aadhaarNumber" value={this.state.aadhaarNumber} onChange={this.handleChange} required />
										<label for="lastname">Aadhaar Number / VID</label>
									</div>
								</div>
								
								<div className="col-12 col-md-6">
									<div className="form-floating">
										<input type="text" className="form-control" id="pan" placeholder="Enter PAN" name="panNumber" value={this.state.panNumber} onChange={this.handleChange} required />
										<label for="pan">PAN Number</label>
									</div>
								</div>					
								
								<div className="col-12 mt-4">
									<div className="form-check">
										<input className="form-check-input" type="checkbox" value="" id="tnc" required />
										<label className="form-check-label tnc" for="tnc">By registering, you confirm that you accept our <a href={process.env.REACT_APP_KYC_Terms_And_Conditions_Link} target="_blank" >terms and conditions</a></label>
									</div>
								</div>
								
								<div className="col-12">
									<button type="submit" className="btn btn-primary" >Proceed</button>
								</div>
							</div>
							</form>							
						</div>
						
						<div className="col-12 col-lg-5 d-none d-lg-block">
                            <div className="rightbanner"><img src={RegisterImg} alt="FinxPay" className="img-fluid"/></div>
						</div>				
					</div>
				</div>
			</div>
		    </div>
	        </div>
            </div>
        );
      } 
}

const mapDispatchToProps = dispatch => ({
    showIciciKycSection: () => dispatch(showIciciKycSection())
});

export default connect(null, mapDispatchToProps)(IciciOnboarding);